/**
 * @flow
 * @author: Chinmaya
 */

import * as React from 'react'

type Props = {}

class HamburgerIcon extends React.Component<Props> {
  render() {
    const { width, height, fillColor, className } = this.props
    return (
      <svg
        className={className}
        fill={fillColor}
        height={height}
        viewBox="0 0 24 24"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
      </svg>
    )
  }
}

HamburgerIcon.defaultProps = {
  fillColor: '#000000',
  width: 24,
  height: 24
}

export default HamburgerIcon
